// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-list-docs',
    templateUrl: './list.docs.generated.html',
})
export class UIListDocs { }
